import memoizeOne from 'memoize-one';

import type * as api from '@gitbook/api-client';

import { getSiteSpacesFromStructure } from './structure';

export type SiteCapability = {
    canAdminSite: boolean;
    canViewSite: boolean;
    installIntegration: boolean;
};

/**
 * Get site permissions for a site.
 */
export function getSitePermissions(input: {
    siteStructure: api.SiteStructure;
    organization: api.Organization;
}): SiteCapability {
    const { siteStructure, organization } = input;
    const getSiteSpaces = memoizeOne(() => getSiteSpacesFromStructure(siteStructure));

    return {
        canAdminSite:
            organization.permissions.createContent ||
            // Since we currently don't store sites permissions directly, we need to infer it from the site's spaces permissions.
            getSiteSpaces().some((siteSpace) => siteSpace.space.permissions.admin),
        canViewSite:
            organization.permissions.admin ||
            // Since we currently don't store sites permissions directly, we need to infer it from the site's spaces permissions.
            getSiteSpaces().some((siteSpace) => siteSpace.space.permissions.access),
        installIntegration: organization.permissions.installIntegration,
    };
}
